export default __webpack_public_path__ + "static/media/Fox.696bb7e3.svg";